<template>
  <div class="we-file-navbar">
    <we-searchbox
      ref="searchbox"
      v-model="searchText"
      :placeholder="placeholder"
      :style="{'width': getWidth()}"/>
    <div
      class="we-file-navbar-nav">
      <Icon type="ios-close-circle-outline" :size="16" class="navbar-cursor"  @click="resetSearchText"/>
      <Icon
        v-if="nav.isShowNav('export')"
        :size="16"
        type="ios-share-outline"
        :title="$t('message.navBar.dataStudio.outTable')"
        class="navbar-cursor"
        @click="exportFrom"/>
      <Icon
        v-if="nav.isShowNav('import')"
        :size="20"
        type="ios-archive-outline"
        :title="$t('message.navBar.dataStudio.importHive')"
        class="navbar-cursor"
        @click="importTo"/>
      <Icon
        v-if="nav.isShowNav('newFile')"
        :size="16"
        type="ios-add-circle-outline"
        :title="addTitle"
        class="navbar-cursor"
        @click="addFile"/>
      <Icon
        v-if="nav.isShowNav('refresh')"
        :size="20"
        type="ios-refresh"
        :title="$t('message.constants.refresh')"
        class="navbar-cursor"
        @click="refresh"/>
    </div>
  </div>
</template>
<script>
import weSearchbox from './searchbox.vue';
import Nav from './nav.js';
export default {
  components: {
    weSearchbox,
  },
  props: {
    navList: {
      type: Array,
      require: true,
    },
    placeholder: {
      type: String,
      default () {
        // 这里不能写成箭头函数 要拿到this值
        // return this.$t('message.navBar.dataStudio.searchPlaceholder')
        return  "搜索……";
      }
    },
    addTitle: {
      type: String,
      default () {
        return this.$t('message.navBar.dataStudio.addTitle')
      }
    },
  },
  data() {
    return {
      nav: null,
      searchText: '',
    };
  },
  watch: {
    searchText: function(value) {
      this.$emit('text-change', value);
    },
  },
  created() {
    this.nav = new Nav({
      navList: this.navList,
    });
  },
  methods: {
    showSearch() {
      this.$nextTick(() => {
        this.$refs.searchbox.onfocus();
      });
    },
    resetSearchText(){
      this.searchText = '';
    },
    refresh() {
      this.searchText = '';
      this.$emit('on-refresh');
    },
    addFile() {
      this.$emit('on-add');
    },
    importTo() {
      this.$emit('on-import');
    },
    exportFrom() {
      this.$emit('on-export');
    },
    getWidth() {

      let px = 19;
      this.navList.forEach(n =>{
        if(n == 'import' || n == 'refresh'){
          px += 23;
        }else{
          px += 19;
        }
      })
      // const len = this.navList.length;
      // if (len === 4) {
      //   px = '68px';
      // } else if (len === 3) {
      //   px = '42px';
      // }
      return `calc(100% - ${px}px)`;
    },
  },
};
</script>
<style lang="scss" src="./index.scss"></style>
